(() => {
  const initCarousel = (section) => {
    if (!section || section.dataset.amaCarouselReady === 'true') return;

    const track = section.querySelector('.ama-home-app__product-strip');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.ama-home-app__quick-product'));
    if (slides.length < 2) return;

    section.dataset.amaCarouselReady = 'true';
    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', 'Produits les plus recherchés');

    const viewport = document.createElement('div');
    viewport.className = 'ama-home-app__carousel-viewport';
    track.parentNode.insertBefore(viewport, track);
    viewport.appendChild(track);

    const makeButton = (direction, label, path) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `ama-home-app__carousel-nav ama-home-app__carousel-nav--${direction}`;
      button.setAttribute('aria-label', label);
      button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}"/></svg>`;
      viewport.appendChild(button);
      return button;
    };

    const prev = makeButton('prev', 'Produit précédent', 'M15 18l-6-6 6-6');
    const next = makeButton('next', 'Produit suivant', 'M9 6l6 6-6 6');

    let currentIndex = 0;
    let ticking = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const targetLeft = (slide) => slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;

    const updateState = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let nearest = 0;
      let nearestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(center - slideCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = index;
        }
      });

      currentIndex = nearest;
      slides.forEach((slide, index) => {
        const active = index === nearest;
        slide.classList.toggle('is-active', active);
        if (active) slide.setAttribute('aria-current', 'true');
        else slide.removeAttribute('aria-current');
      });

      prev.disabled = nearest === 0;
      next.disabled = nearest === slides.length - 1;
    };

    const goTo = (index, smooth = true) => {
      const bounded = Math.max(0, Math.min(index, slides.length - 1));
      currentIndex = bounded;
      track.scrollTo({
        left: targetLeft(slides[bounded]),
        behavior: smooth && !reduceMotion ? 'smooth' : 'auto'
      });
      updateState();
    };

    prev.addEventListener('click', () => goTo(currentIndex - 1));
    next.addEventListener('click', () => goTo(currentIndex + 1));

    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateState();
        ticking = false;
      });
    }, { passive: true });

    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(currentIndex + 1);
      }
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => goTo(currentIndex, false));
      resizeObserver.observe(track);
    }

    requestAnimationFrame(() => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const initialIndex = mobile ? 0 : Math.min(1, slides.length - 1);
      goTo(initialIndex, false);
    });
  };

  const init = () => document.querySelectorAll('.ama-home-app__products').forEach(initCarousel);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
